"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CurrencyInput = void 0;
var react_1 = __importStar(require("react"));
var MaskedInput_1 = require("./MaskedInput");
var LabelContext_1 = require("../labels/LabelContext");
var CurrencyInput = function (_a) {
    var _b = _a.options, options = _b === void 0 ? {} : _b, _c = _a.rightAlign, rightAlign = _c === void 0 ? true : _c, props = __rest(_a, ["options", "rightAlign"]);
    var handleOnChange = function (value) {
        var formattedValue = parseFloat(value.replace(/[^\d.+-]/g, ''));
        if (isNaN(formattedValue)) {
            props.onChange && props.onChange(null);
        }
        else {
            props.onChange && props.onChange(formattedValue);
        }
    };
    var labelCtx = (0, react_1.useContext)(LabelContext_1.LabelContext);
    return (react_1.default.createElement(MaskedInput_1.MaskedInput, __assign({}, props, { options: {
            mask: '$num',
            blocks: {
                num: __assign({ mask: Number }, options),
            },
        }, value: props.value ? props.value.toString() : '', onChange: handleOnChange, rightAlign: rightAlign, "aria-labelledby": props.describedBy || labelCtx.describedBy })));
};
exports.CurrencyInput = CurrencyInput;
//# sourceMappingURL=CurrencyInput.js.map